// Helper puri per la galleria prodotto per colore (Task 2, piano
// 2026-10-11-looniva-direzione-a.md). Nessuna dipendenza dal DOM: testabili
// con `node --test` senza Liquid ne' un browser (tests/design-system/71-galleria.test.mjs).
//
// Mappa l'id dello swatch del selettore colore dei set (#lnv-pc-root,
// snippets/looniva-color-block.liquid, array COLORS) al colore normalizzato
// usato nella convenzione degli alt (docs/redesign/media-alt.json,
// docs/superpowers/plans/2026-10-11-looniva-direzione-a.md riga 17): i nomi
// visibili dello swatch non coincidono sempre col nome scritto nell'alt.
// Verificato leggendo snippets/looniva-color-block.liquid:
//   bianco     -> "Bianco"      -> bianco
//   crema      -> "Nebbia"      -> nebbia
//   beige      -> "Sabbia"      -> sabbia
//   grigio     -> "Grigio"      -> grigiochiaro (alt ammesso: "Grigio chiaro")
//   salvia     -> "Salvia"      -> salvia
//   azzurro    -> "Ottanio"     -> ottanio
//   navy       -> "Navy"        -> blunavy (alt ammesso: "Blu navy")
//   terracotta -> "Terracotta"  -> terracotta
var PICKER_TO_ALT_COLOR = {
  bianco: 'bianco',
  crema: 'nebbia',
  beige: 'sabbia',
  grigio: 'grigiochiaro',
  salvia: 'salvia',
  azzurro: 'ottanio',
  navy: 'blunavy',
  terracotta: 'terracotta',
};

// Normalizza un nome colore come nel suffisso dell'alt: minuscolo, senza spazi.
function normalise(value) {
  return (value == null ? '' : String(value)).trim().toLowerCase().replace(/\s+/g, '');
}

// Id dello swatch del picker (es. "crema") -> colore normalizzato dell'alt
// (es. "nebbia"). Stringa vuota se l'id non e' mappato.
function pickerIdToAltColor(pickerId) {
  var key = normalise(pickerId);
  return Object.prototype.hasOwnProperty.call(PICKER_TO_ALT_COLOR, key) ? PICKER_TO_ALT_COLOR[key] : '';
}

// slides: array di { colore: string } (colore gia' normalizzato, '' se la
// slide non ha colore, cioe' sempre visibile). chosenColorNorm: colore
// normalizzato scelto nel picker, o '' se nessuna scelta / prodotto a
// colore singolo. Ritorna gli indici delle slide da mostrare: le slide del
// colore scelto piu' quelle senza colore; se nessuna slide ha quel colore,
// tutte le slide (comportamento di sicurezza richiesto dal piano).
function selectVisibleSlides(slides, chosenColorNorm) {
  var list = slides || [];
  var allIndexes = list.map(function (_, i) { return i; });

  if (!chosenColorNorm) return allIndexes;

  var matched = [];
  for (var i = 0; i < list.length; i++) {
    var colore = list[i] && list[i].colore;
    if (!colore || colore === chosenColorNorm) matched.push(i);
  }

  return matched.length > 0 ? matched : allIndexes;
}

var api = {
  PICKER_TO_ALT_COLOR: PICKER_TO_ALT_COLOR,
  normalise: normalise,
  pickerIdToAltColor: pickerIdToAltColor,
  selectVisibleSlides: selectVisibleSlides,
};

if (typeof module !== 'undefined' && module.exports) {
  module.exports = api;
} else {
  window.lvGallery = api;
}
